module.exports = __webpack_public_path__ + "static/media/img.0be1151d.webp";